import { useEffect } from 'react';

import { useToolPlayControllerContext } from '@/component/Tool/ToolPlayController';
import { Redo, SettingsBackupRestore, Undo, useShortcut } from '@/package';
import { useLabelingBoxContext } from '@/provider';
import { useToolMenuStore, useToolPermissionStore } from '@/store';

import ToolbarGroup from './ToolbarGroup';
import ToolbarMenu from './ToolbarMenu';

const HistoryToolbarGroup = () => {
  const { namespace, register, unregister } = useShortcut();
  const { isPlaying } = useToolPlayControllerContext();
  const { history } = useLabelingBoxContext();
  const { clear, undo, redo, pastStates, futureStates } = history.getState();
  const { toolMap, findByName, select } = useToolMenuStore();
  const isUndoDisabled = pastStates.length === 0;
  const isRedoDisabled = futureStates.length === 0;
  const { permission } = useToolPermissionStore();
  const isLabelUpdatable = permission.labeling.updatable;

  const undoTool = findByName('undo')!;
  const redoTool = findByName('redo')!;
  const revertTool = findByName('revert')!;

  useEffect(() => {
    undoTool.isSelected && undo();
    redoTool.isSelected && redo();
    if (revertTool.isSelected) {
      undo(history.getState().pastStates.length);
      clear();
    }
  }, [toolMap]);

  useEffect(() => {
    register(undoTool.command!, () => select(undoTool.id));
    register(redoTool.command!, () => select(redoTool.id));
    register(revertTool.command!, () => select(revertTool.id));

    return () => {
      unregister(undoTool.command!);
      unregister(redoTool.command!);
      unregister(revertTool.command!);
    };
  }, [namespace]);

  return (
    <ToolbarGroup visibleDivider>
      <ToolbarMenu
        disabled={isPlaying || isUndoDisabled || !isLabelUpdatable}
        toolMenuItem={undoTool}
        onClick={() => select(undoTool.id)}
      >
        <Undo className="size-4!" />
      </ToolbarMenu>

      <ToolbarMenu
        disabled={isPlaying || isRedoDisabled || !isLabelUpdatable}
        toolMenuItem={redoTool}
        onClick={() => select(redoTool.id)}
      >
        <Redo className="size-4!" />
      </ToolbarMenu>

      <ToolbarMenu
        disabled={isPlaying || isUndoDisabled || !isLabelUpdatable}
        toolMenuItem={revertTool}
        onClick={() => select(revertTool.id)}
      >
        <SettingsBackupRestore className="size-4!" />
      </ToolbarMenu>
    </ToolbarGroup>
  );
};

export default HistoryToolbarGroup;
